import { render, staticRenderFns } from "./imgCmp.vue?vue&type=template&id=2406acec&scoped=true&"
import script from "./imgCmp.vue?vue&type=script&lang=js&"
export * from "./imgCmp.vue?vue&type=script&lang=js&"
import style0 from "./imgCmp.vue?vue&type=style&index=0&id=2406acec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2406acec",
  null
  
)

export default component.exports